import React, { useState, useCallback } from 'react';
import { createTask } from 'modules/tasks/http';
import { Button, Textarea } from '@ontruck/orc';
import Icon from '@ontruck/ontruck-react-components/lib/Icon';
import OrderSearch from './OrderSearch';
import AgentSearch from './AgentSearch';
import Schedule from './Schedule';

export const t = {
  title: 'New task',
  create: 'Create task',
  textarea_placeholder: 'Write down task instructions',
  checkbox: 'Set up timer to trigger the task',
};

const TaskCreation = ({ className, setShowCreateTask }) => {
  const [idValue, setIdValue] = useState(null);
  const [descriptionValue, setDescriptionValue] = useState(null);
  const [ownerValue, setOwnerValue] = useState(null);
  const [creatingTask, setCreatingTask] = useState(false);
  const [date, setDate] = useState(new Date().toISOString());
  const [showScheduling, setShowScheduling] = useState(false);

  const buttonDisabled = !idValue || !descriptionValue || creatingTask;

  const handleTextAreaChange = useCallback((e, { value }) => {
    setDescriptionValue(value);
  }, []);

  const handleClose = useCallback(() => {
    setShowCreateTask(false);
  }, [setShowCreateTask]);

  const handleChangeDate = useCallback((date) => {
    setDate(date);
  }, []);

  const handleCreateTask = useCallback(async () => {
    if (!idValue || !descriptionValue) return;
    setCreatingTask(true);
    await createTask({
      journey_id: idValue.value,
      comment: descriptionValue,
      owner_id: ownerValue?.value,
      ...(showScheduling ? { scheduled_for: date } : {}),
    });
    setCreatingTask(false);
    handleClose();
  }, [idValue, descriptionValue, ownerValue, handleClose, date, showScheduling]);

  return (
    <div className={className}>
      <div className="header">
        <span className="header__title">{t.title}</span>
        <span className="header__close" onClick={handleClose}>
          <Icon name="close" />
        </span>
      </div>
      <div className="selectors">
        <span>
          <OrderSearch value={idValue} setIdValue={setIdValue} />
        </span>
        <span>
          <AgentSearch value={ownerValue} setValue={setOwnerValue} idValue={idValue} />
        </span>
      </div>
      <Schedule
        showScheduling={showScheduling}
        setShowScheduling={setShowScheduling}
        handleChangeDate={handleChangeDate}
        date={date}
      />
      <div>
        <Textarea
          fullWidth
          value={descriptionValue}
          labelType="hidden"
          height={showScheduling ? '48px' : '74px'}
          width="100%"
          onChange={handleTextAreaChange}
          placeholder={t.textarea_placeholder}
        />
      </div>
      <div className="action">
        <Button
          disabled={buttonDisabled}
          onClick={handleCreateTask}
          noWrap
          skin="primary"
          text={t.create}
        />
      </div>
    </div>
  );
};

export default TaskCreation;
